import { type Shift, shiftPeriodToTimeSlot } from "@src/appV2/Shifts/Shift/types";
import { useGetFacilityBreakConfiguration } from "@src/appV2/Shifts/Shift/useGetFacilityBreakConfiguration";
import { type ReactNode } from "react";

import { ShiftWithContentCard } from "../../Shift/Card/CardWithContent";
import { getFormattedShiftPayBreakdown } from "../../Shift/getFormattedShiftPayBreakdown";
import { getShiftWorkDurationInHours } from "../../utils/getShiftWorkDuration";

interface UnverifiedShiftCardWithBreakConfigProps {
  shift: Shift;
  children: ReactNode;
}

export function UnverifiedShiftCardWithBreakConfig({
  shift,
  children,
}: UnverifiedShiftCardWithBreakConfigProps) {
  // Fetch break configuration for this specific shift
  const { mandatoryBreakDurationInMinutes } = useGetFacilityBreakConfiguration({
    workplaceId: shift.facility.userId,
  });

  const shiftPayBreakdown = getFormattedShiftPayBreakdown(
    shift.offer?.pay.value,
    shift.finalPay,
    shift.originalAmount
  );

  const shiftWorkDurationInHours = getShiftWorkDurationInHours(
    shift,
    shift.facility.requiresLunchBreak ?? false,
    mandatoryBreakDurationInMinutes
  );

  return (
    <ShiftWithContentCard
      shiftTimeSlot={shiftPeriodToTimeSlot[shift.name]}
      shiftStart={shift.start}
      shiftEnd={shift.end}
      shiftQualificationName={shift.agentReq}
      shiftHourlyPay={shiftPayBreakdown?.hourlyPay}
      shiftTotalPay={shiftPayBreakdown?.totalPay}
      shiftWorkDurationInHours={shiftWorkDurationInHours}
      workplaceName={shift.facility.name}
      workplaceTimezone={shift.facility.tmz ?? ""}
    >
      {children}
    </ShiftWithContentCard>
  );
}
